import { Input as MUIInput, InputAdornment } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { memo, useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
	search: {
		background: theme.palette.grey.main,
		borderRadius: "10px",
		position: "relative",
		padding: "5px 10px",
	},
}));

const Search = ({
	value: searchValue,
	width = "100%",
	height = "40px",
	onChange,
}) => {
	const classes = useStyles();
	const [value, setValue] = useState(searchValue);

	useEffect(() => {
		setValue(searchValue);
	}, [searchValue]);

	return (
		<MUIInput
			disableUnderline
			type="search"
			placeholder="Search"
			value={value}
			name="search"
			className={classes.search}
			sx={{ width, height }}
			endAdornment={(
				<InputAdornment sx={{ display: value ? "none" : "flex" }}>
					<SearchIcon />
				</InputAdornment>
			)}
			onChange={onChange}
		/>
	);
};

export default memo(Search);
